import React, { ComponentProps } from 'react';
import { Loading as CarbonLoading } from '@carbon/react';

export type LoadingProps = ComponentProps<typeof CarbonLoading>;

export const Loading = ({ children, ...props }: LoadingProps) => (
  <CarbonLoading {...props}>{children}</CarbonLoading>
);
